<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 101 }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planType: 101, planName: form.getFieldsValue().planName }"
                searchParam="planVersion"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, planType: 101 }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <global-select
                v-decorator="['statusList']"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_PR_RELEASE_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="计划员">
              <global-select
                v-decorator="['plannerCodeList']"
                selectType="selectMultiple"
                requestApi="/system/user/allJobCodeName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料类别">
              <a-tree-select
                v-decorator="['categoryIdList']"
                class="w100-pc"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码">
              <global-select
                v-decorator="['itemIdList']"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, organizationCode: form.getFieldsValue().organizationCode || organizationCodeOrigin }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="仅查询不满足MOQ的物料" :labelCol="{ style: { width: '160px' } }">
              <a-switch v-decorator="['switchOne']" :checked="form.getFieldsValue().switchOne" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="显示">
              <global-select
                v-decorator="['lineTypeList']"
                selectType="selectMultiple"
                :selectData="lineTypeListData"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="MRP版本">
              <global-select
                v-decorator="['mrpVersionNumber', { rules: [{ required: true }] }]"
                ref="mrpSelectRef"
                selectType="selectSearch"
                :selectItem="{ value: 'realValue', label: 'label' }"
                requestApi="/scp/scpMrpPlans/mrpVersionNumberBox"
                searchParam="mrpVersionNumber"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(form.getFieldsValue())">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '100px' } }">
          <a-row class="align-center">
            <div class="plan-time pt5 pb5">计划运行概况</div>
            <a-col :md="7" :sm="24" class="ml20">
              <a-form-item label="主计划版本">
                <a-input v-model="scheduleVersion" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="计划运算完成时间" :labelCol="{ style: { width: '120px' } }">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div class="table-page-operator-wrapper mt5 mb10">
          <!-- <a-button @click="handleDevelop">全部折叠</a-button>
          <a-button @click="handlePackUp">全部展开</a-button> -->
          <a-button @click="handleExport" v-hasPermi="['scp:scpMrpHorizontalSummary:reservePlanExport']">导出</a-button>
          <a-button @click="importExcelHandleOpen" v-hasPermi="['scp:scpMrpHorizontalSummary:reservePlanImport']">导入并发布</a-button>
          <a-button :loading="fbLoading" :disabled="selectedRows.length === 0" type="primary" @click="handleFb()" v-hasPermi="['scp:scpMrpHorizontalSummary:reservePlanRelease']">发布</a-button>
          <a-button @click="handleZbfb()" v-hasPermi="['scp:scpMrpHorizontalSummary:reservePlanFullRelease']">整版发布</a-button>
          <a-button :loading="recallLoading" :disabled="selectedRows.length === 0" @click="handleRecall()" v-hasPermi="['scp:scpMrpHorizontalSummary:reservePlanWithdraw']">撤回</a-button>
        </div>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :expandedRowKeys="expandedRowKeys"
          :scroll="{ x: tableX, fixScreen: true }"
          @successCallBack="successCallBack"
        >
          <span slot="checkboxTitle">
            <a-checkbox :checked="allChecked" @change="allCheckedChange"></a-checkbox>
          </span>
          <span slot="lineTypeNameTitle" class="align-center">项目&nbsp;
            <a-popover>
              <template slot="content">
                <p>针对需求总量不满足MOQ的情况，可在此选择按MOQ采购、按实际需求采购、或是不采购。</p>
              </template>
              <span><a-icon type="info-circle" /></span>
            </a-popover>
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record, index }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="(!isEdit || currentId !== record.serialNumber) && record.lineType === 'ASSIGN_QTY' && editStatusList.includes(record.status)" @click="handleEdit(record)" v-hasPermi="['scp:scpMrpHorizontalSummary:reservePlanEdit']">编辑</a>
                <a v-if="isEdit && currentId === record.serialNumber" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.serialNumber" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.dataIndex === 'checkbox' && record.boss">
                <a-checkbox v-if="record.serialNumber" :checked="record[item.dataIndex]" @change="(e) => { checkedChange(e, index) }"></a-checkbox>
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== record.serialNumber">{{ record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === record.serialNumber" v-model="record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="(record.boss || columnsAdd.includes(item.dataIndex)) && Number(text) < 0" :class="['color-red', {'line-ellipsis':item.ellipsis}]" :title="item.ellipsis ? text : ''">{{ text }}</span>
              <span v-else-if="(record.boss || columnsOther.includes(item.dataIndex) && record.lineType === 'ASSIGN_QTY' )" :class="{ 'line-ellipsis': item.ellipsis }" :title="item.ellipsis ? text : ''">{{ text }}</span>
              <span v-else-if="(record.boss || item.dataIndex === 'initial' && record.lineType === 'PROJECTED_ONHAND' )" :class="{ 'line-ellipsis': item.ellipsis }" :title="item.ellipsis ? text : ''">{{ text }}</span>
              <span v-else-if="(record.boss || columnsAdd.includes(item.dataIndex))" :class="{ 'line-ellipsis': item.ellipsis }" :title="item.ellipsis ? text : ''">{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk" />
        <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
        <!-- 上传文件 -->
        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          @ok="importExcelHandleCancel"
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="true"
            :headers="upload.headers"
            :action="`${upload.url}?updateSupport=${upload.updateSupport}&planVersion=${form.getFieldsValue().planVersion || ''}`"
            @change="importExcelHandleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              请将文件拖拽到此处上传
            </p>
            <p class="ant-upload-hint">
              支持单个或批量上传，也可以点击后选择文件上传
            </p>
          </a-upload-dragger>
        </a-modal>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpMrpHorizontalSummaryReservePlanList,
  apiScpMrpCategoryCodeCategoryBox,
  apiScpScreeningSchemeSearchAllScheme,
  apiScpMrpPlansCallMaterialPlanExecutionTime,
  apiScpMrpHorizontalDatesDateDisplayList,
  apiScpMrpHorizontalSummaryReservePlanRelease,
  apiScpMrpHorizontalSummaryReservePlanFullRelease,
  apiScpMrpHorizontalSummaryReservePlanEdit,
  apiScpMrpPlansPlanVersionBox,
  apiScpMrpHorizontalSummaryReservePlanWithdraw
} from '@/api/scp/reserve-goods-plan/reserve-plan-query'
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import Cookies from 'js-cookie';
import { generateLsTableResData } from '@/utils/util.js';
export default {
  // eslint-disable-next-line
  name: 'Reserve-plan-query', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DressingByScreening,
    DressingByScreeningSetUp
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpMrpHorizontalSummary/reservePlanImport'
      },
      isEdit: false,
      currentId: "",
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpHorizontalSummaryReservePlanList, true),
        pageCurrent: true
      },
      // 查询参数
      form: this.$form.createForm(this),
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 3100,
      tableList: [],
      // 表格字段
      columnsOrigin: [],
      columnsAdd: [],
      columnsOther: ['supplierCode', 'supplierName', 'prPoSummary', 'inTransit', 'qonhand', 'moqTypeName', 'moq'],
      columns: [
        {
          // title: '复选框',
          dataIndex: 'checkbox',
          scopedSlots: { customRender: 'checkbox', title: "checkboxTitle" },
          width: 50,
          fixed: 'left'
        },
        {
          title: '组织',
          dataIndex: 'organizationName',
          scopedSlots: { customRender: 'organizationName' },
          align: 'center',
          width: 120,
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode' },
          align: 'center',
          width: 120,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'uom',
          scopedSlots: { customRender: 'uom' },
          align: 'center',
          width: 100,
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          scopedSlots: { customRender: 'itemName' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          scopedSlots: { customRender: 'specification' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '一级分类',
          dataIndex: 'name1',
          scopedSlots: { customRender: 'name1' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '二级分类',
          dataIndex: 'name2',
          scopedSlots: { customRender: 'name2' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '三级分类',
          dataIndex: 'name3',
          scopedSlots: { customRender: 'name3' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '审批意见',
          dataIndex: 'approvalComments',
          scopedSlots: { customRender: 'approvalComments' },
          align: 'center'
        },
        {
          title: 'MPQ',
          dataIndex: 'fixedLotMultiplier',
          scopedSlots: { customRender: 'fixedLotMultiplier' },
          align: 'center'
        },

        {
          title: '备库L/T',
          dataIndex: 'safetyStockLeadTime',
          scopedSlots: { customRender: 'safetyStockLeadTime' },
          align: 'center'
        },
        {
          title: 'VMI库存',
          dataIndex: 'onhand',
          scopedSlots: { customRender: 'onhand' },
          align: 'center'
        },
        {
          title: '产业园期初',
          dataIndex: 'onhandVendorAssign',
          scopedSlots: { customRender: 'onhandVendorAssign' },
          align: 'center'
        },
        {
          title: '产业园盈余',
          dataIndex: 'invInTransitQty',
          scopedSlots: { customRender: 'invInTransitQty' },
          align: 'center'
        },
        {
          title: 'VMI在途',
          dataIndex: 'poInTransitQty',
          scopedSlots: { customRender: 'poInTransitQty' },
          align: 'center'
        },
        {
          title: '储备单',
          dataIndex: 'prPoQty',
          scopedSlots: { customRender: 'prPoQty' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          scopedSlots: { customRender: 'statusName' },
          align: 'center'
        },
        {
          title: '供应商编号',
          dataIndex: 'supplierCode',
          scopedSlots: { customRender: 'supplierCode' },
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          scopedSlots: { customRender: 'supplierName' },
          align: 'center'
        },
        {
          title: '供应商未发储备单',
          dataIndex: 'prPoSummary',
          width: 160,
          scopedSlots: { customRender: 'prPoSummary' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '供应商送货在途数',
          dataIndex: 'inTransit',
          scopedSlots: { customRender: 'inTransit' },
          align: 'center',
          width: 160,
          ellipsis: true
        },
        {
          title: '库存现有量',
          dataIndex: 'qonhand',
          scopedSlots: { customRender: 'qonhand' },
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: 'MOQ处理',
          dataIndex: 'moqTypeName',
          scopedSlots: { customRender: 'moqTypeName' },
          align: 'center'
        },
        {
          title: 'MOQ',
          dataIndex: 'moq',
          scopedSlots: { customRender: 'moq' },
          align: 'center'
        },
        {
          // title: '项目',
          dataIndex: 'lineTypeName',
          scopedSlots: { customRender: 'lineTypeName', title: "lineTypeNameTitle" },
          align: 'center'
        },
        {
          title: '总数量',
          dataIndex: 'summary',
          scopedSlots: { customRender: 'summary' },
          align: 'center'
        },
        {
          title: '期初',
          dataIndex: 'initial',
          scopedSlots: { customRender: 'initial' },
          align: 'center'
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          scopedSlots: { customRender: 'planName' },
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          scopedSlots: { customRender: 'planVersion' },
          align: 'center'
        },
        {
          title: 'MRP版本',
          dataIndex: 'mrpVersionNumber',
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      lineTypeListData: [], // 显示
      searchList1: [],
      searchList2: [],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      allChecked: false,
      treeData: [], // 物料类别
      scheduleVersion: "", // 主计划版本
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "", // 计划运算完成时间
      expandedRowKeys: [], // table 展开
      editStatusList: ["UNRELEASE", "REJECT", "RECALL"], // 待发布、已驳回、已撤回
      fbLoading: false,
      recallLoading: false
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.columnsOrigin = JSON.parse(JSON.stringify(this.columns))
    this.getLookupList('SCP_MRP_LINE_TYPE_PR', 'lineTypeListData')
    this.getCategoryIdList(true)
    this.getSearchAllScheme()

    this.form.setFieldsValue({
      organizationCode: this.organizationCodeOrigin
    })
  },
  mounted () {},
  methods: {
    recursiveExpand (arr, tmp) {
      for (let i = 0; i < arr.length; i++) {
        tmp.push(arr[i].id)
        if (arr[i].childList !== null && arr[i].childList !== undefined && arr[i].childList.length > 0) {
          this.recursiveExpand(arr[i].childList, tmp)
        }
      }
      return tmp
    },
    // 全部展开
    handleDevelop () {
      const tableList = JSON.parse(JSON.stringify(this.tableList))
      this.recursiveExpand(tableList, this.expandedRowKeys)
    },
    // 全部收起
    handlePackUp () {
      this.expandedRowKeys = [];
    },
    // 撤回
    handleRecall () {
      let flag = false
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (this.selectedRows[i].status !== "IN_APPROVAL") {
          flag = true
          this.$message.error("只有审批中的状态才可以撤回")
        }
      }
      if (flag) {
        return false
      }
      this.recallLoading = true
      apiScpMrpHorizontalSummaryReservePlanWithdraw(this.selectedRowKeys).then(response => {
        if (response.code === 200) {
          this.$message.success('撤回成功!')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
        this.recallLoading = false
      }).catch(e => {
        this.recallLoading = false
      })
    },
    // 发布
    handleFb () {
      this.fbLoading = true
      apiScpMrpHorizontalSummaryReservePlanRelease(this.selectedRows).then(response => {
        if (response.code === 200) {
          this.$message.success('发布成功!')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
        this.fbLoading = false
      }).catch(e => {
        this.fbLoading = false
      })
    },
    // 整版发布
    handleZbfb () {
      const self = this
      this.$confirm({
        title: '发布提醒',
        content: '整版发布将发布所有符合查询条件的储备计划，请确认是否继续执行发布。',
        okText: '继续发布',
        cancelText: '取消',
        icon: () => <a-icon type='info-circle' class="color-2ea1ff" />,
        onOk () {
          apiScpMrpHorizontalSummaryReservePlanFullRelease(self.form.getFieldsValue()).then(response => {
            if (response.code === 200) {
              self.$message.success('整版发布成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      });
    },
    // 新增/修改框事件
    handleOk () {
      this.getCategoryIdList()
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      if (!this.form.getFieldsValue().mrpVersionNumber) {
        this.$message.warning('MRP版本不能为空')
        return;
      }
      this.isEdit = false
      this.getTableTime()
      this.lineTypeListChange(this.form.getFieldsValue().lineTypeList)

      const params = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
      params.switchOne = params.switchOne ? "Y" : "N"
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData();
    },
    successCallBack (myDataSource) {
      const tableList = JSON.parse(JSON.stringify(myDataSource))
      const arr2 = tableList.map(item => item.id)
      const arr3 = Array.from(new Set(arr2))
      const arr4 = []
      for (let i = 0; i < tableList.length; i++) {
        tableList[i].checkbox = false
        for (let j = 0; j < arr3.length; j++) {
          if (tableList[i].id === arr3[j] && !arr4.includes(arr3[j])) {
            arr4.push(arr3[j])
            tableList[i].boss = true
          }
        }
      }
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
      this.allChecked = false
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.form.setFieldsValue(JSON.parse(val.schemeDetailJson))
      this.getPlanVersion()
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.serialNumber !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.columns = JSON.parse(JSON.stringify(this.columns))
      this.isEdit = true;
      this.currentId = record.serialNumber;
    },
    // 编辑-保存
    handleSave (record) {
      const obj = JSON.parse(JSON.stringify(record))
      const arr = []
      for (const item in obj) {
        if (item.substring(0, 4).indexOf("date") >= 0) {
          arr.push(obj[item])
        }
      }

      const params = {
        id: record.id,
        quantitiesId: record.quantitiesId,
        dataList: arr
      }
      apiScpMrpHorizontalSummaryReservePlanEdit(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
     this.onSearch()
     this.isEdit = false
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.tableList = [];
      if (this.$refs?.mrpSelectRef) {
        this.$refs.mrpSelectRef.handleSearch("");
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.onSearch()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/scpMrpHorizontalSummary/reservePlanExport', {
        ...this.form.getFieldsValue()
      }, `储备计划查询/发布_${new Date().getTime()}.xlsx`)
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    // 计划版本字段-自动填充
    getPlanVersion () {
      apiScpMrpPlansPlanVersionBox({ dataType: 2, planType: 102, planName: this.form.getFieldsValue().planName }).then(res => {
        this.form.setFieldsValue({
          planVersion: ""
        })
        if (res.rows && res.rows.length > 0) {
          res.rows.forEach(element => {
            if (element.bringOutDataOne === "Y") {
              this.form.setFieldsValue({
                planVersion: element.realValue
              })
            }
          });
        }
        this.onSearch()
      })
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.form.setFieldsValue(JSON.parse(element.schemeDetailJson))
              this.getPlanVersion()
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    getTableTime () {
      // 数据收集时间、计划运算完成时间
      apiScpMrpPlansCallMaterialPlanExecutionTime(this.form.getFieldsValue()).then(res => {
        if (res.data) {
          this.dataCollectStartDate = res.data.dataCollectStartDate && this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss') || ""
          this.planCompletionDate = res.data.planCompletionDate && this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss') || ""
          this.scheduleVersion = res.data.scheduleVersion || ""
        }
      })
      // 动态表头
      apiScpMrpHorizontalDatesDateDisplayList({ planVersion: this.form.getFieldsValue().planVersion, dataType: "PR" }).then(res => {
        if (res.data && res.data.length > 0) {
          const columns = JSON.parse(JSON.stringify(this.columnsOrigin))
          const arr = res.data
          const arr2 = ['lineTypeName', 'summary']
          arr.forEach((element, index) => {
            const obj = {
              title: element,
              dataIndex: `date${index + 1}`,
              scopedSlots: { customRender: `date${index + 1}` },
              type: 'inputNumber'
            }
            arr2.push(`date${index + 1}`)
            columns.splice(-3, 0, obj);
          });
          this.columnsAdd = arr2 || []
          this.columns = columns
          this.tableX = 3000 + res.data.length * 100
        } else {
          this.columns = JSON.parse(JSON.stringify(this.columnsOrigin))
        }
      })
    },
    // 全选
    allCheckedChange (e) {
      this.allChecked = e.target.checked;
      const tableList = JSON.parse(JSON.stringify(this.tableList))
      const arr = []
      const arr2 = []
      tableList.forEach(element => {
        if (element.boss) {
          element.checkbox = this.allChecked ? this.allChecked : false
          arr.push(element.id)
          arr2.push(element)
        }
      });
      this.selectedRowKeys = this.allChecked ? arr : []
      this.selectedRows = this.allChecked ? arr2 : []
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
    },
    // 选择
    checkedChange (e, index) {
      const tableList = JSON.parse(JSON.stringify(this.tableList))
      tableList[index].checkbox = e.target.checked

      const arr = []
      const arr2 = []
      tableList.forEach(element => {
        if (element.checkbox) {
          arr.push(element.id)
          arr2.push(element)
        }
      });
      this.selectedRowKeys = arr
      this.selectedRows = arr2
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
    },
    // table的页码控制
    lineTypeListChange (val) {
      if (!val || val.length === 0) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 20
        return
      }
      if (val.length === 1 || val.length === 5) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["10", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 10
      }
      if (val.length === 2 || val.length === 4) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["8", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 8
      }
      if (val.length === 3) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["9", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 9
      }
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "SCP_MRP_LINE_TYPE_PR") {
          const arr2 = []
          response.rows.forEach(element => {
            if (element.attribute2 === "Y") {
              arr2.push(element.lookupCode)
            }
          });
          this.form.setFieldsValue({
            lineTypeList: arr2
          })
        }
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.plan-time{
  font-weight: bold;
}
/deep/.ant-select-selection__choice{
  width: 66.47px;
}
.color-red {
  color: red
}
.color-2ea1ff{
  color: #2ea1ff !important;
}
</style>
